import { supabase } from '@/integrations/supabase/client';

export async function fetchOnboardingEnabled(): Promise<boolean> {
  const { data, error } = await supabase
    .from('onboarding_global_settings' as any)
    .select('enabled')
    .eq('id', true)
    .maybeSingle();
  if (error) {
    console.error('[onboardingGlobal] fetch error:', error);
    return true; // fail-open: keep onboarding ativo se houver erro
  }
  return (data as any)?.enabled !== false;
}

export async function setOnboardingEnabled(enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('onboarding_global_settings' as any)
    .update({ enabled, updated_at: new Date().toISOString() })
    .eq('id', true);
  if (error) throw error;
}